import React, { useState } from 'react';
import { Text, H4, Box } from '@bigcommerce/big-design';
import { DragIndicatorIcon } from '@bigcommerce/big-design-icons';

const TemplateLineOrderContainer = ({
  barcode,
  storeLogo,
  barcodeSymbol,
  productName,
  optionOne,
  optionTwo,
  optionThree,
  price,
  brand,
  mpn,
  bpn,
  arbitraryText,
  barcodeSymbolPriority,
  productNamePriority,
  optionOnePriority,
  optionTwoPriority,
  optionThreePriority,
  pricePriority,
  brandPriority,
  mpnPriority,
  bpnPriority,
  arbitraryTextPriority,
  line,
  customFieldOptions,
  reorderElements
}) => {

  const [dragIndex, setDragIndex] = useState(null);
  const [dropIndex, setDropIndex] = useState(null);

  let lineElements = [];

  if (barcodeSymbol) {
    lineElements.push({
      element: 'Barcode Symbol',
      priority: barcodeSymbolPriority,
      standard: true
    })
  }

  if (productName) {
    lineElements.push({
      element: 'Product Name',
      priority: productNamePriority,
      standard: true
    })
  }

  if (optionOne) {
    lineElements.push({
      element: 'Variation Option 1',
      priority: optionOnePriority,
      standard: true
    })
  }

  if (optionTwo) {
    lineElements.push({
      element: 'Variation Option 2',
      priority: optionTwoPriority,
      standard: true
    })
  }

  if (optionThree) {
    lineElements.push({
      element: 'Variation Option 3',
      priority: optionThreePriority,
      standard: true
    })
  }

  if (price) {
    lineElements.push({
      element: 'Price',
      priority: pricePriority,
      standard: true
    })
  }

  if (brand) {
    lineElements.push({
      element: 'Brand',
      priority: brandPriority,
      standard: true
    })
  }

  if (mpn) {
    lineElements.push({
      element: 'MPN',
      priority: mpnPriority,
      standard: true
    })
  }

  if (bpn) {
    lineElements.push({
      element: 'BPN',
      priority: bpnPriority,
      standard: true
    })
  }

  if (arbitraryText) {
    lineElements.push({
      element: 'Branding Text',
      priority: arbitraryTextPriority,
      standard: true
    })
  }

  if (customFieldOptions?.length > 0) {
    customFieldOptions.forEach((customField, index) => {
      if(customField.field_name.length > 0 && ( customField.line === line )) {
        lineElements.push({
          element: customField.field_name,
          priority: customField.priority,
          standard: false,
          fieldIndex: index
        })
      }
    })
  }

  lineElements.sort((a,b) => a.priority - b.priority)

  if(barcode) {
    return(
      <Box
        backgroundColor="primary20"
        border="box"
        borderRadius="normal"
        padding="medium"
      >
        <H4>Barcode Line</H4>
        <Text>Only the barcode appears on barcode lines. Text elements on this line will not appear.</Text>
      </Box>
    )
  }

  if(storeLogo) {
    return(
      <Box
        backgroundColor="primary20"
        border="box"
        borderRadius="normal"
        padding="medium"
      >
        <H4>Store Logo Line</H4>
        <Text>Only the logo appears on store logo lines. Text elements on this line will not appear.</Text>
      </Box>
    )
  }

  if(lineElements.length === 0) {
    return (
      <Box
        backgroundColor="warning20"
        border="box"
        borderRadius="normal"
        padding="medium"
      >
        <H4>Empty Line</H4>
        <Text>No text elements selected for this line. Enable an element and select this line number from its dropdown in the "Label Parts" section to add to this line.</Text>
      </Box>
    )
  }

  return (
    <div>
      {lineElements.map((element, index) => (
        <div
          id={`line-element-${element.priority}`}
          key={element.element}
          className={`flex-container template-line-row${dropIndex === index && dragIndex !== index ? ' drag-over' : ''}`}
          draggable
          onDragStart={(e) => {
            e.dataTransfer.setData('text/plain', index);
            e.dataTransfer.effectAllowed = 'move';
            setDragIndex(index);
          }}
          onDragOver={(e) => {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            setDropIndex(index);
          }}
          onDragLeave={() => setDropIndex(null)}
          onDrop={(e) => {
            e.preventDefault();
            reorderElements(dragIndex, index, lineElements);
            setDragIndex(null);
            setDropIndex(null);
          }}
          onDragEnd={() => {
            setDragIndex(null);
            setDropIndex(null);
          }}
        >
          <div className="drag-handle">
            <DragIndicatorIcon />
          </div>
          <div className="flex-4 text-center">
            <Text>{element.element}</Text>
          </div>
        </div>
      ))}
    </div>
  )

}

export default TemplateLineOrderContainer;
